import React from 'react'
import './Sixthsection.css'
function sixthsection() {
    return (
        <div>
        <div className="" id="topContainer6">
        <div className="container">
        <div className="col-md-6 box" id="education">
        <h3 id="educationhead">Education</h3>
        <p className="content61">
        Crescent University Abeokuta (2012-2017)
        BSC Computer Science With Statistics
        Thesis: Design and Implementation of a Facial Recogniton and Detection System.
        This project was carried out to build a system that focus on unique characteristics
        of each individual human facial feature to identify a person. This approach
        helps tackle the plastice surgery issue, even after an individual under goes plastic
        surgery the system is built to identify the individual by taking specific data from the
        face that can not be unchanged to identify each individual person. 
        
        </p>
        </div>

        <div className="col-md-6 box" id="experience">
        <h3 id="experiencehead">Experience</h3>
        <div id="exitems">

        <div id="Suitescomng1" >
        <p className="exrole">UX Designer </p>
         <p className="excompany"> 9gridz (2021 - Present)</p>
        <p className="content6">
        - Applied knowledge of digital and user centred design principles in solving user 
        problems and creating simple, easy to use interfaces.
        <br/>
        - Plan and lead the creation of usable digital products, developing interaction 
        strategies, navigation and flow, building wireframes and interactive prototypes, 
        organizing content, and advocating for real users' requirements and goals. <br/>
        - Directly collaborating with clients, problem-solving and actively listening to and 
        interpreting their needs, and ensuring their satisfaction.<br/>
        
         </p>
         </div> 

        <div id="Brainshare">
        <p className="exrole">Brand Identity/Creative and UX Design</p>
        <p className="excompany">Brainshare Technologies. (2021)</p>
        <p className="content6">
        - Managed and collaborated with the AlphaOTT USA team involving the executive 
        director, 2 UX designers and 3 developers. <br/>
        - Engaging the wider team and key stakeholders in the user centred design process, 
        ensuring that user research is customer service focused at the heart of design 
        decision making and direction.<br/>
        - Being a team player working closely with the creative and development team 
        member, receiving feedback to develop exciting new products including web and 
        mobile apps, microsites, email campaigns and more.<br/>
        - Worked with the CTO, product manager and development teams to integrate 
        responsive and adaptable user interface, welcome screen, signup/login, user 
        profile, avatars, home screen, navigation, categories and other product service 
        delivery.<br/>
        - Developed and create wireframing and working prototypes to prove design 
        concepts and test user flows.<br/>
        - Present design concepts using a storyboard to break down explanations for design 
        decisions, supported by industry research and best practices.<br/>
        - Improved user experience and workflow on a variety of digital platforms, including 
        the web, Android and iOS.<br/>
        - Create the brand merchandise and stationeries, T-shirts, ID cards, business cards, 
        water bottles, pens and more.<br/>
        - Designed and create the brand style guide, typography, visuals/digital design and 
        guaranteed corporate identity and communication were consistent.<br/>
        </p>
        </div>
        <div id="BMC" >
        <p className="exrole">Creative Designer, Social Media Executive <br/> and UX Designer.</p>
         <p className="excompany">Bosworth Marketing Consulting. (2020)</p>
        
        <p className="content6">
        - Mentoring and presenting information and insight to clients and creative team 
members.<br/>
- Leading and managing the implementation of social digital channels, resulted in a 
15% improvement in conversion rate.<br/>
- Managed 4 vendors for the Bajaj Auto project with cross functional teams 
consisting of 18 members.<br/>
- Negotiating with vendors to obtain a 9% budget decrease.<br/>
- Perform clean design of the user interface and other digital materials across 
marketing, client delivery and proposal.<br/>
- I've worked on a variety of projects for companies like Bajaj Auto, Philips, 
Coldstone Creamery and Wrigley Company.<br/>
- Branding of various companies like School of Experience and Brand Experience 
Optimizer.
         </p>
         </div> 
         
</div>

 <div id="exitems1"> 
        
        
        <div id="ojireh">
        <p className="exrole">Concepts and Creatives</p>
        <p className="excompany">Ojireh. (2018)</p>
        <p className="content6">
        I take customers from the uncertainty, stress and anxiety to clarity, warmth,
        and great deal of understanding as regards a particular product or service using
        design & art</p>
        </div>
        
       <div id="NB">
        <p className="exrole">IT personnel</p>
        <p className="excompany">Nigerian Breweries Plc. (2016)</p>
       <p className="content6">
       Basicly designed ads to target a specific audience to create even more  demand for a 
       particular brand.</p></div>

       <div id="RoadBuddies" >
       <p className="exrole">UX Designer (Freelance) </p>
        <p className="excompany">Road Buddies (2020)</p>
       
       <p className="content6">
       - Collaborate with product owner, development and QA teams on the mockups and navigation flows.<br/>
       - Understand and work well with outputs from user and stakeholder research, being able to synthesize 
       insight to shape your design work and its outcomes.
        </p>
        </div> 

       </div>


       <div id="exitems2">

      

        <div id="golfmedia">
        <p className="exrole">Photography/Graphics Design</p>
        <p className="excompany">Golfmedia. (2015)</p>
        <p className="content6">
        I help clients maintain the memory lineage with photography and graphics design
        to tell incredible stories. Also creating awesome banners, photo book cover and more,
        I capture the most amazing memories at weddings and events, apply creative skills to
        giving each wedding and event a cinematic feel.
        </p>
        </div>

        </div>

    


        </div>
        </div>
        </div>
        </div>
    )
} 

export default sixthsection
